export async function pegarProporcoesDeImagem(imageUrl, fixedWidth) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
            // A imagem foi carregada, agora calcula a altura proporcional
            const originalWidth = img.width;
            const originalHeight = img.height;
            const scaleFactor = fixedWidth / originalWidth;
            const proportionalHeight = originalHeight * scaleFactor;

            resolve({
                width: fixedWidth,
                height: Math.round(proportionalHeight) // Arredonda para evitar valores fracionários
            });
        };
        img.onerror = () => {
            reject(new Error("Não foi possível carregar a imagem."));
        };
        img.src = imageUrl;
    });
}
